module.exports = __webpack_public_path__ + "img/semitrailerRearLeftOutline.c7327eb8.svg";